import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import { getBlogBySlug } from "../API/BlogAPI";

const BlogDetails = () => {
  const { Id } = useParams(); // get slug from URL
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        setLoading(true);
        const res = await getBlogBySlug(Id);
        if (res?.status && res?.responseData) {
          setBlog(res.responseData);
        } else {
          setBlog(null);
        }
      } catch (error) {
        console.error("Error fetching blog:", error);
        setBlog(null);
      } finally {
        setLoading(false);
      }
    };
    fetchBlog();
  }, [Id]);

  // 🔹 Loading Spinner
  if (loading) {
    return (
      <div className="min-h-full bg-gray-50">
        <Breadcrumb title="Blog Details" path="Blog Details" />
        <div className="flex justify-center items-center h-96">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-theme2"></div>
        </div>
      </div>
    );
  }

  // 🔹 No Blog Found
  if (!blog) {
    return (
      <div className="min-h-full bg-gray-50">
        <Breadcrumb title="Blog Details" path="Blog Details" />
        <div className="flex justify-center items-center h-96">
          <p className="text-gray-500 text-lg">Blog not found.</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <Breadcrumb title="Blog Details" path="Blog Details" />
      <section className="py-12 container mx-auto px-4">
        <img
          src={blog.BannerImage}
          alt={blog.Title}
          className="w-auto mx-auto lg:h-[40rem] md:h-[35rem] mb-6 h-[25rem] rounded-md"
        />

        <div className="flex items-center justify-between mb-6 md:flex-row flex-col">
          <h1 className="text-darktext font-bold md:text-2xl text-xl mb-2 md:mb-0">
            {blog.Title}
          </h1>
          <p className="text-darktext">
            {new Date(blog.EntDt).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>
        </div>

        {/* Blog Content */}
        <div
          className="leading-7 prose max-w-none text-contentcolor"
          dangerouslySetInnerHTML={{ __html: blog.Content }}
        />
      </section>
    </>
  );
};

export default BlogDetails;
